module.exports = __webpack_public_path__ + "ba0e0c141ef1471d6847a108ddeade2c.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/bulorounded-regularitalic.woff
 ** module id = 10
 ** module chunks = 0
 **/